module.exports = __webpack_public_path__ + "img/presentation-chart-02.af2a9b08.svg";